import { Injectable } from '@angular/core';
import { Routes } from '@angular/router';

import { MenuItem, MenuSection } from '../../core/models/menu-item.model';
import { MenuRegistryService } from '../../core/services/menu-registry.service';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

const menuItems: MenuItem[] = [
  {
    id: 'biologicalSampling',
    name: 'Muestreos Biológicos',
    type: 'research',
    dataSource: { url: 'research/biological-sampling' },
    icon: 'science',
    order: 1,
    neededClaim: getClaimString(
      AppFeature.ResearchBiologicalSampling,
      AppActions.Read
    ),
  },
];

const menuSection: MenuSection = {
  id: 'research',
  name: 'Investigación',
  items: menuItems,
  order: 3,
  neededClaim: getClaimString(AppFeature.Research, AppActions.Read),
};

@Injectable({
  providedIn: 'root',
})
export class BiologicalSamplingModule {
  constructor(private menuRegistry: MenuRegistryService) {
    this.menuRegistry.registerModule(menuSection);
  }

  /**
   * Static method to get menu items (for external access)
   */
  static getMenuItems(): MenuItem[] {
    return menuItems;
  }

  /**
   * Static method to get routes (for external access)
   */
  static getRoutes(): Routes {
    return BiologicalSamplingModule.getRoutes();
  }
}
